import { useQueryState, parseAsString } from "nuqs";

/**
 *
 * Custom hook to set/get the redirect URL from the query state.
 */
const useRedirectUrl = () => {
  return useQueryState(
    "redirectTo",
    parseAsString
      .withOptions({ clearOnDefault: true })
      .withDefault("")
  );
}

export default useRedirectUrl;